import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".811",
  d: "M8.406 27.526a44.64 44.64 0 0 1 23.185-8.695M11.987 31.595A44.76 44.76 0 0 1 31.59 21.373M21.337 31.595a45 45 0 0 1 10.257-6.894"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".811",
  d: "M8.406 18.756c4.074.215 8.099.988 11.964 2.295l.202.06M19.567 15.232c.878-6.573-5.855-4.726-7.421-6.83 0 .374-1.528 8.314 5.438 7.667M22.244 15.887c5.236 1.121 5.29-4.999 5.29-4.999s-6.412.136-5.29 4.999"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".811",
  d: "M16.634 12.9s4.114 1.87 4.114 5.61"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }